import React from "react";
import EditIcon from "../icons/editIcon";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../../helpers/approvalSettings/functions";
import {checkIfQuestionHasPendingChanges} from "../../helpers/questions/functions";
import {INFO_TEXT_EDIT_WITH_APPROVAL, INFO_TEXT_EDIT_WITHOUT_APPROVAL} from "../../helpers/variables";

const QuestionEditActions = (props) => {
    const {
        isPlain,
        checkIfQuestionIsEditable,
        question,
        openEditQuestionAnswerModal,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        formData,
        application
    } = props;

    return (
        <div>
            {
                [
                    isPlain
                    && checkIfQuestionIsEditable(
                        question
                    ) && (
                        <EditIcon
                            key={1}
                            informationText={
                                checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                    mapEditingQuestionOrFieldToEditingSetting(question),
                                    approvalOptions
                                ) ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
                            }
                            className={
                                checkIfQuestionAnswerUpdateRequiresARAGApproval(
                                    mapEditingQuestionOrFieldToEditingSetting(question),
                                    approvalOptions
                                ) ? "edit-icon--orange" : null
                            }
                            onClick={() => openEditQuestionAnswerModal({
                                questionAnswerForEdit: question,
                                questionAnswer: formData[question.id]
                            })}
                        />
                    ),
                    checkIfQuestionHasPendingChanges(question.id, application) && (
                        <div className={"newApplication__awaiting-approval-wrapper pull-right"} key={2}>
                            Awaiting Approval
                        </div>
                    ),
                ]
            }
        </div>
    )
};

export default QuestionEditActions;